module.exports = __webpack_public_path__ + "img/Dama-logo-white.eb2a678f.svg";